"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const app_1 = require("./app");
const responseError = require("./common/responseError");
const identifiers_1 = require("./identifiers");
const getContent_1 = require("./getContent");
function getStudentSubmissions({ studentId, courseId, domainId, studentSubmissionId }) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            let studentSubmissionsRef = app_1.app.firestore.collection(`studentSubmissions`);
            if (studentSubmissionId) {
                const submissionDocSnapshot = yield studentSubmissionsRef
                    .doc(studentSubmissionId)
                    .get();
                return [Object.assign({ id: submissionDocSnapshot.id }, submissionDocSnapshot.data())];
            }
            else {
                // build query
                if (domainId) {
                    studentSubmissionsRef = studentSubmissionsRef.where('domainId', '==', domainId);
                }
                if (studentId) {
                    studentSubmissionsRef = studentSubmissionsRef.where('userId', '==', studentId);
                }
                if (courseId) {
                    studentSubmissionsRef = studentSubmissionsRef.where('courseId', '==', courseId);
                }
                // execute query
                const studentSubmissionsGreaterQueryPromise = studentSubmissionsRef
                    .where('submissionState', '>', identifiers_1.Types.SubmissionStates.INACTIVE).get();
                const studentSubmissionsLessQueryPromise = studentSubmissionsRef
                    .where('submissionState', '<', identifiers_1.Types.SubmissionStates.INACTIVE).get();
                const studentSubmissionsQueryPromises = [];
                studentSubmissionsQueryPromises.push(studentSubmissionsGreaterQueryPromise);
                studentSubmissionsQueryPromises.push(studentSubmissionsLessQueryPromise);
                const studentSubmissionsQueryResolvedDocs = yield Promise.all(studentSubmissionsQueryPromises);
                const studentSubmissionsQuerySnapshotDocs = [];
                for (const studentSubmissionsQueryResolvedDoc of studentSubmissionsQueryResolvedDocs) {
                    for (const studentSubmissionsQuerySnapshotDoc of studentSubmissionsQueryResolvedDoc.docs) {
                        studentSubmissionsQuerySnapshotDocs.push(studentSubmissionsQuerySnapshotDoc);
                    }
                }
                // append contentJSON to docs
                const promises = [];
                for (const studentSubmissionsQuerySnapshotDoc of studentSubmissionsQuerySnapshotDocs) {
                    const studentSubmissionDoc = Object.assign({ id: studentSubmissionsQuerySnapshotDoc.id }, studentSubmissionsQuerySnapshotDoc.data());
                    promises.push(appendContentJSON(studentSubmissionDoc));
                }
                const docs = yield Promise.all(promises);
                console.log('Student Submissions', docs);
                return docs;
            }
        }
        catch (e) {
            throw new responseError.HttpsError(responseError.FunctionsErrorCode.invalid_argument, e.message);
        }
    });
}
exports.default = getStudentSubmissions;
function appendContentJSON(studentSubmissionDoc) {
    return __awaiter(this, void 0, void 0, function* () {
        const contentJSON = yield getContent_1.default({ contentIds: [studentSubmissionDoc.contentId] });
        const doc = Object.assign({}, studentSubmissionDoc, { contentJSON: contentJSON[0] });
        return doc;
    });
}
//# sourceMappingURL=getStudentSubmissions.js.map